var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('client-topbar',{on:{"drawerEvent":function($event){_vm.drawer = !_vm.drawer}}}),_c('client-sidebar'),_c('v-main',{staticStyle:{"background":"#f5f5f540"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }